var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _vm.hasNoProject
          ? _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("h4", { staticClass: "not-found" }, [
                  _vm._v("Desculpe! Projeto inexistente ou não disponível.")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "not-found-back" },
                  [
                    _c("router-link", { attrs: { to: "/projects" } }, [
                      _vm._v("Ir para Lista de ONGs")
                    ])
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.project
          ? _c("div", { staticClass: "project-header" }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "breadcrumb-list" }, [
                      _c("ul", [
                        _c(
                          "li",
                          [
                            _c("router-link", { attrs: { to: "/projects" } }, [
                              _vm._v("PROJETOS")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.project &&
                        _vm.project.projectType != "event" &&
                        _vm.project.Categories[0].name
                          ? _c(
                              "li",
                              { staticClass: "category" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to:
                                        "/projects/" +
                                        _vm.project.Categories[0].url
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.project.Categories[0].name.toUpperCase()
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.project &&
                        _vm.project.projectType != "event" &&
                        !_vm.project.Categories[0].name &&
                        _vm.project.Categories[1].name
                          ? _c(
                              "li",
                              { staticClass: "category" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to:
                                        "/projects/" +
                                        _vm.project.Categories[1].url
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.project.Categories[1].name.toUpperCase()
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("li", { staticClass: "active" }, [
                          _vm._v(
                            _vm._s(_vm.project ? _vm.project.Info.title : null)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.isAuth &&
                      (_vm.user.isAdmin || _vm.user.profile != "ong")
                        ? _c("div", { staticClass: "button" }, [
                            _c(
                              "a",
                              {
                                staticClass: "favorite",
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.markAsFavorite()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    !_vm.isFavorite
                                      ? "Seguir Projeto"
                                      : "Seguindo"
                                  ) + " "
                                ),
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: [
                                      !_vm.isFavorite ? "far" : "fas",
                                      "heart"
                                    ],
                                    size: "lg"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-7" }, [
                    _c(
                      "div",
                      { staticClass: "project-content" },
                      [
                        _c(
                          "carousel",
                          {
                            staticClass: "carousel",
                            attrs: {
                              autoplay: false,
                              perPage: 1,
                              paginationEnabled: true,
                              autoplayHoverPause: true,
                              loop: true,
                              autoplayTimeout: 5000
                            }
                          },
                          [
                            _vm.project &&
                            (_vm.project.Info.video ||
                              _vm.project.Info.videoUrl)
                              ? _c("slide", { staticClass: "slide" }, [
                                  _c(
                                    "div",
                                    { staticClass: "embed-container" },
                                    [
                                      _c("iframe", {
                                        attrs: {
                                          src: _vm.video,
                                          frameborder: "0",
                                          allowfullscreen: ""
                                        }
                                      })
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("slide", { staticClass: "slide" }, [
                              _c("div", { staticClass: "embed-container" }, [
                                _c("img", {
                                  attrs: {
                                    src:
                                      _vm.project.Info.image &&
                                      _vm.project.Info.image.length > 0 &&
                                      _vm.project.Info.image.search(
                                        "via.placeholder.com"
                                      ) == -1
                                        ? _vm.project.Info.image
                                        : "https://via.placeholder.com/800x500&text=Sem+Foto"
                                  }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.project.Images, function(img, k) {
                              return _vm.project.Images
                                ? _c(
                                    "slide",
                                    { key: k, staticClass: "slide" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "embed-container" },
                                        [_c("img", { attrs: { src: img.url } })]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-5" }, [
                    _c("div", { staticClass: "project-action" }, [
                      _c("h2", [
                        _vm._v(
                          _vm._s(_vm.project ? _vm.project.Info.title : null)
                        )
                      ]),
                      _vm._v(" "),
                      _vm.project.Manager
                        ? _c("div", { staticClass: "person-name" }, [
                            _c("ul", { staticClass: "person-social" }, [
                              _c("li", [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.project.Manager.name) +
                                      " " +
                                      _vm._s(_vm.project.Manager.organization)
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm._m(0),
                              _vm._v(" "),
                              _c("li", [
                                _c("p", [
                                  _c("i", { staticClass: "fa fa-map-marker" }),
                                  _vm._v(
                                    _vm._s(_vm.project.Manager.address) +
                                      " " +
                                      _vm._s(_vm.project.Manager.hood) +
                                      " " +
                                      _vm._s(_vm.project.Manager.city) +
                                      " "
                                  )
                                ])
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.project.Donations
                        ? _c("div", { staticClass: "donations" }, [
                            _c("span", { staticClass: "price-donation" }, [
                              _vm._v(_vm._s(_vm.getDonationsValue()))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "text-right" }, [
                              _vm._v("de "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.project.Donations.length))
                              ]),
                              _vm._v(" doador(es)")
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.project
                        ? _c("div", { staticClass: "actions row" }, [
                            _c("div", { staticClass: "button donation" }, [
                              _vm.user.isAdmin || _vm.user.profile != "ong"
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "donate",
                                      attrs: { href: "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          return _vm.donate()
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: {
                                          icon: ["fas", "dollar-sign"],
                                          size: "lg"
                                        }
                                      }),
                                      _vm._v(" Doar\n                  ")
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _vm.isAuth
                              ? _c("div", { staticClass: "button donation" }, [
                                  _vm.user.isAdmin || _vm.user.profile != "ong"
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "donate-click",
                                          attrs: { href: "" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.donateQuickly()
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: {
                                              icon: ["fas", "dollar-sign"],
                                              size: "lg"
                                            }
                                          }),
                                          _vm._v(
                                            " Doe com um Clique\n                  "
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "actions sharing row" }, [
                        _c("div", { staticClass: "button" }, [
                          _c(
                            "a",
                            {
                              staticClass: "share-facebook",
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.facebookShare()
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fab", "facebook"], size: "lg" }
                              }),
                              _vm._v(" Compartilhe\n                  ")
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "button" }, [
                          _c(
                            "a",
                            {
                              staticClass: "share-whatsapp",
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.whatsappShare()
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fab", "whatsapp"], size: "lg" }
                              }),
                              _vm._v(" Compartilhe\n                  ")
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "actions row" }),
                      _vm._v(" "),
                      _vm.ODS && _vm.ODS.length > 0
                        ? _c("div", { staticClass: "project-ods" }, [
                            _c("h2", [
                              _vm._v("Objetivos de Desenvolvimento Sustentável")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c(
                                  "carousel",
                                  {
                                    staticClass: "carousel",
                                    attrs: {
                                      autoplay: true,
                                      perPage: 4,
                                      paginationEnabled: false,
                                      autoplayHoverPause: true,
                                      loop: true,
                                      autoplayTimeout: 3000
                                    }
                                  },
                                  _vm._l(_vm.ODS, function(slug, i) {
                                    return _c(
                                      "slide",
                                      { key: i, staticClass: "slide col-md-3" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              target: "_blank",
                                              href: _vm.getODS(slug).url
                                            }
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: _vm.getODS(slug).image
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.project
          ? _c("div", { staticClass: "project-body" }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-7" }, [
                    _c("div", { staticClass: "project-description" }, [
                      _c("h2", [_vm._v("Nosso projeto")]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.project ? _vm.project.Info.description : null
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "project-share" }, [
                      _c("h2", [_vm._v("Compartilhe este projeto")]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn facebook-share",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.facebookShare()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fab", "facebook"], size: "lg" }
                          }),
                          _vm._v(" Facebook\n              ")
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.project.Activities
                      ? _c(
                          "div",
                          { staticClass: "project-activities" },
                          [
                            _c("h2", [
                              _vm._v("Atividades "),
                              _c("b", [
                                _vm._v(_vm._s(_vm.project.Activities.length))
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.project.Activities, function(a, k) {
                              return _c(
                                "div",
                                { key: k, staticClass: "activity" },
                                [
                                  _c("h4", [_vm._v(_vm._s(a.title))]),
                                  _vm._v(" "),
                                  _c("div", {
                                    domProps: { innerHTML: _vm._s(a.text) }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.getTimeAgo(a.timestamp)))
                                  ])
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "project-comments" },
                      [
                        _c("h2", [_vm._v("Comentários")]),
                        _vm._v(" "),
                        _c("vue-disqus", {
                          attrs: {
                            shortname: "https-click2giv-com",
                            identifier: _vm.slug,
                            url: "https://click2giv.com/project/" + _vm.slug
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-5" }, [
                    _vm.project &&
                    _vm.donationsList &&
                    _vm.donationsList.length > 0
                      ? _c("div", { staticClass: "project-donations" }, [
                          _c("h2", [
                            _vm._v("Doadores "),
                            _c("b", [
                              _vm._v(_vm._s(_vm.project.Donations.length))
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            _vm._l(_vm.donationsList, function(donation) {
                              return _c(
                                "li",
                                {
                                  key: donation.DonationId,
                                  staticClass: "row"
                                },
                                [
                                  _c("div", { staticClass: "col-md-3" }, [
                                    !donation.visibility && donation.picture
                                      ? _c("img", {
                                          attrs: { src: donation.picture }
                                        })
                                      : _c("img", {
                                          staticClass: "no-user",
                                          attrs: { src: _vm.noUser }
                                        })
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-9" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.convertToReal(donation.value)
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    !donation.visibility && donation.name
                                      ? _c("p", [_vm._v(_vm._s(donation.name))])
                                      : _c("p", [
                                          _c("i", [_vm._v("Doação Anônima")])
                                        ])
                                  ])
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "mustLogin",
          attrs: { "hide-footer": "", title: "Perfil não autorizado" }
        },
        [
          _c("div", { staticClass: "d-block text-center" }, [
            _c("h5", [
              _vm._v("Olá! O seu perfil de 'ONG' não permite realizar doações.")
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "userDonationModal",
          attrs: {
            "ok-only": true,
            size: "md",
            "ok-title": "Processar Doação",
            id: "userDonationModal",
            title: "Informe um valor a ser doado"
          },
          on: { ok: _vm.submitFormDonation }
        },
        [
          _c(
            "form",
            {
              ref: "formPayment",
              staticClass: "donationForm",
              attrs: { method: "post" }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Valor de Doação")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "span",
                          {
                            staticClass: "input-group-text",
                            attrs: { id: "basic-addon1" }
                          },
                          [_vm._v("R$")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "money",
                            rawName: "v-money",
                            value: _vm.money,
                            expression: "money"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.donationValue,
                            expression: "donationValue"
                          }
                        ],
                        staticClass: "form-control input-value",
                        attrs: {
                          required: "",
                          type: "text",
                          name: "value",
                          placeholder:
                            "Informe o valor que deseja doar para o projeto"
                        },
                        domProps: { value: _vm.donationValue },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.donationValue = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Mensagem")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.donationMessage,
                          expression: "donationMessage"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "message",
                        placeholder:
                          "Escreva uma mensagem para a equipe do projeto"
                      },
                      domProps: { value: _vm.donationMessage },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.donationMessage = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.donationModalMsg
                ? _c(
                    "div",
                    {
                      staticClass:
                        "alert alert-danger alert-dismissible fade show",
                      attrs: { role: "alert" }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.donationModalMsg) +
                          "\n        "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "alert",
                            "aria-label": "Fechar"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.hideMsg()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { staticClass: "contact", attrs: { href: "" } }, [
        _vm._v("Contato")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5dd84899", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dd84899","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project.vue
// module id = null
// module chunks = 